const theme = {
    background: "transparent",
    text: {
        fontSize: '1rem'
    },
    tooltip: {
        container: {
            background: "rgba(255,255,255, 0.8)",
            color: "#333333",
            fontSize: "0.85rem",
        }
    }
};

export default theme;